import { Table, TablePagination, useProductOrderRequestListContext } from '@components';
import { useAuth } from '@hooks';
import { ProductOrderRequestListRow } from './ProductOrderRequestListRow';
import { productOrderRequestListColumns } from './productOrderRequestList.config';

export const ProductOrderRequestList = () => {
  const { isWorking, isError, list, id, offset, totalCount, itemsPerPage } =
    useProductOrderRequestListContext();
  const { isBeremaUser } = useAuth();

  return (
    <>
      <Table
        headerColumns={productOrderRequestListColumns(isBeremaUser)}
        isWorking={isWorking}
        isError={isError}
        list={list}
        renderRow={(productOrderRequest) => (
          <ProductOrderRequestListRow
            key={productOrderRequest.id}
            productOrderRequest={productOrderRequest}
            isWorking={isWorking}
          />
        )}
      />
      <TablePagination
        id={id}
        start={offset}
        totalCount={totalCount}
        itemsPerPage={itemsPerPage}
        isWorking={isWorking}
      />
    </>
  );
};
